const ElementPanel = ({
  variableName,
  inputType,
  displayFriendlyVariableName,
}) => {
  return (
    <div className="bg-auto-mid rounded-xl px-3 pb-3 pt-3">
      <h1 className="text-auto-white  px-1 mb-2 text-xs font-semibold">
        {displayFriendlyVariableName}
      </h1>

      {inputType == "text" ? (
        <div className="input-text w-full">
          <input
            type="text"
            placeholder={`Enter a value for ${displayFriendlyVariableName.toLowerCase()}`}
            className="inline-block w-full  bg-auto-dark  rounded-md border-0 py-0.5 text-auto-white placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-xs sm:leading-6"
          />
        </div>
      ) : inputType == "number" ? (
        <div className="input-number">
          <input
            type="number"
            className="inline-block  bg-auto-dark flex-1/2 rounded-md border-0 py-0.5 text-auto-white  placeholder:text-auto-white placeholder:opacity-40 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-xs sm:leading-6"
          />
        </div>
      ) : inputType == "date" ? (
        <div className="input-date">
          <input
            type="date"
            className="inline-block  bg-auto-dark flex-1/2 rounded-md border-0 py-0.5 text-auto-white placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-xs sm:leading-6"
          />
        </div>
      ) : (
        <div>Invalid input</div>
      )}
    </div>
  );
};
export default function Interface({ inputObject }) {
  return (
    <div className="space-y-2">
      {inputObject.map((element) => (
        <ElementPanel {...element} />
      ))}
    </div>
  );
}
